import React, { useEffect, useRef, useState } from 'react';
import styles from './paymentPage.module.css';
import { useLocation } from 'react-router-dom';

const PaymentPage = ({ paymentData, cancelSelectionCredit, setLoading, setCreditCard }) => {
  const tap = useRef(null);
  const card = useRef(null);
  const [isReady, setIsReady] = useState(false); // Track whether everything is ready
   const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");

  // useEffect(() => {
  //   if (window.Tapjsli) {
  //     //tap.current = window.Tapjsli('pk_test_HR3G5J7y6cd8gzDmluQE1UtX'); // Your public key here
  //     if(paymentData.requestType == "ActivePolicyRecurring" || paymentData.requestType == "ForRecurring"){
  //       tap.current = window.Tapjsli(process.env.REACT_APP_TAP_LIFE_KEY); // Your public key here
  //     }
  //     else{
  //       tap.current = window.Tapjsli(process.env.REACT_APP_TAP_KEY); // Your public key here
  //     }
     

  //     if (tap.current && !card.current) {
  //       initializeTapPayment();
  //     }
  //   } else {
  //     console.error('Tapjsli is not loaded.');
  //   }
  // }, []);

   useEffect(() => {
      if (window.Tapjsli && paymentData?.requestType) {
        // Determine the correct key based on payment type upfront
        const requestType = (paymentData.requestType || '').toLowerCase();
        const shouldUseLifeKey = requestType === 'activepolicyrecurring' || requestType === 'forrecurring';
        
        console.log('Initializing with correct key for:', paymentData.requestType);
        console.log('Using LIFE_KEY?', shouldUseLifeKey);
        
        // Debug environment variables
      console.log('TAP_KEY:', process.env.REACT_APP_TAP_KEY ? 'exists' : 'undefined');
      console.log('TAP_LIFE_KEY:', process.env.REACT_APP_TAP_LIFE_KEY ? 'exists' : 'undefined');
      
      let apiKey;
      if (shouldUseLifeKey) {
        apiKey = process.env.REACT_APP_TAP_LIFE_KEY;
        console.log('Selected LIFE_KEY:', apiKey ? 'exists' : 'undefined');
      } else {
        apiKey = process.env.REACT_APP_TAP_KEY;
        console.log('Selected TAP_KEY:', apiKey ? 'exists' : 'undefined');
      }
      
      // Fallback if the preferred key is undefined
      if (!apiKey) {
        console.warn('Selected API key is undefined, falling back to TAP_KEY');
        apiKey = process.env.REACT_APP_TAP_KEY;
      }
      
      if (apiKey) {
        console.log('Initializing Tapjsli with key:', apiKey.substring(28) + '...');
        tap.current = window.Tapjsli(apiKey);
        
        if (tap.current && !card.current) {
          initializeTapPayment();
        }
      } else {
        console.error('No valid API key found');
      }
    } else {
      console.error('Tapjsli is not loaded or paymentData not available.');
    }
    }, [paymentData?.requestType]); // Watch for paymentData.requestType

  const CreateCharge = async (token) => {
  
        const url = process.env.REACT_APP_PAYMENT_API+"Payment/CreateCharge";
        const data = {
          Token: token,
          amount: paymentData.amount, 
          Quote: paymentData.quotationNumber, 
          transaction: paymentData.quotationNumber, 
          CustomerId: paymentData.custId, 
          RedirectLink: paymentData.requestType == "General Payment" ? process.env.REACT_APP_SB_HUB+"invoice?quote="+paymentData.quotationNumber : process.env.REACT_APP_SB_HUB+"policy-documents?policy="+paymentData.quotationNumber,
          WebHookLink: paymentData.requestType  == 'deductible' ? process.env.REACT_APP_PAYMENT_API+"Payment/ClaimPaymentWebHook" : paymentData.requestType  == 'depreciation' ? process.env.REACT_APP_PAYMENT_API+"Payment/ClaimPaymentWebHook" : process.env.REACT_APP_PAYMENT_API+"Payment/PaymentStatus",
          isRecurring: paymentData.requestType == "ForRecurring" || paymentData.requestType == "ActivePolicyRecurring" ? true : false,
          PaymentType: paymentData.requestType,
          encryptedToken: id,
          ProductName: paymentData.ProductName
        };
   
        try {
          setCreditCard(false);
          setLoading(true);
          console.log('Creating charge with data:', data);

          const response = await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "*/*",
            },
            body: JSON.stringify(data),
          });
  
          if (!response.ok) {
            throw new Error("Failed to fetch payment requests");
          }
  
          const result = await response.json();
          return result;
          
        } catch (error) {
          setLoading(false);
        
          //setFormLoading(false);
          console.error("Error fetching payment requests:", error);
        }
      
    };

  const initializeTapPayment = () => {
    const elements = tap.current.elements({});

    const style = {
      base: {
        color: '#535353',
        lineHeight: '18px',
        fontFamily: 'sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: 'rgba(0, 0, 0, 0.26)',
          fontSize: '15px'
        }
      },
      invalid: {
        color: 'red'
      }
    };

    const labels = {
      cardNumber: "Card Number",
      expirationDate: "MM/YY",
      cvv: "CVV",
      cardHolder: "Card Holder Name"
    };

    const paymentOptions = {
      currencyCode: ["BHD"],
      labels: labels,
      TextDirection: 'ltr',
      paymentAllowed: ['VISA', 'MASTERCARD', 'AMERICAN_EXPRESS']
    };

    card.current = elements.create('card', { style: style }, paymentOptions);
    card.current.mount('#element-container');

    card.current.addEventListener('change', (event) => {
      const displayError = document.getElementById('error-handler');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });

    setIsReady(true); // Mark payment system as ready
  };

  const onSubmit = (event) => {
    event.preventDefault();


    // Ensure that the Tap and Card objects are properly initialized
    if (tap.current && card.current) {
      console.log('Tap object:', tap.current);
      console.log('Card object:', card.current);
      // Add a check if createToken is actually available
      if (typeof tap.current.createToken === 'function') {
        tap.current.createToken(card.current)
          .then(async (result) => {
            console.log(result);
            if (result.error) {
              const errorElement = document.getElementById('error-handler');
              errorElement.textContent = result.error.message;
            } else {
              const successElement = document.getElementById('success');
              successElement.style.display = 'block';
              const tokenElement = document.getElementById('token');
              tokenElement.textContent = result.id;
              var res = await CreateCharge(result.id);
              var link = res["transaction"]["url"];           
              tapTokenHandler(result.id, link);
              //window.location.href(link);
              console.log("Check Tap Payments Res", res);
             // window.open(link);
            }
          })
          .catch((error) => {
            console.error('Error creating token:', error);
          });
      } else {
        console.error('createToken is not available');
      }
    } else {
      console.error('Tap or card is not initialized properly.');
    }
  };

  const tapTokenHandler = (token, link) => {
    const form = document.getElementById('payment-form');
    const hiddenInput = document.createElement('input');
    hiddenInput.setAttribute('type', 'hidden');
    hiddenInput.setAttribute('name', 'tapToken');
    hiddenInput.setAttribute('value', token);
    window.location.href = link;
    form.appendChild(hiddenInput);
    
    // Submit the form
    form.submit();
    
  };

  return (
    <>
      <style>
        {`
          .form-row {
            width: 70%;
            float: left;
            background-color: #ededed;
          }
          #card-element {
            background-color: transparent;
            height: 40px;
            border-radius: 4px;
            border: 1px solid transparent;
            box-shadow: 0 1px 3px 0 #e6ebf1;
            -webkit-transition: box-shadow 150ms ease;
            transition: box-shadow 150ms ease;
          }

          #card-element--focus {
            box-shadow: 0 1px 3px 0 #cfd7df;
          }

          #card-element--invalid {
            border-color: #fa755a;
          }

          #card-element--webkit-autofill {
            background-color: #fefde5 !important;
          }

          #submitbutton, #tap-btn {
          
            cursor: pointer;
            height: 35px;
            margin-top: 28px;
           
          }

          #tap-btn:disabled {
            background-color: #ccc;
            cursor: not-allowed;
          }
        `}
      </style> 

      <main>
        <form id="form-container" className="container" onSubmit={onSubmit}>
          <div className='bg-blue rounded-lg'>
          <div id="element-container"></div>
          </div>
          
          <div id="error-handler" role="alert"></div>
          <div id="success" style={{ display: 'none', position: 'relative', float: 'left' }}>
            Success! Your token is <span id="token"></span>
          </div>
          <div className="flex justify-between">
          <button type='button' id="tap-btn" onClick={cancelSelectionCredit} className='rounded-lg w-full mr-4 text-sm bg-white border font-semibold'>Cancel</button>
       
          <button id="tap-btn" className='rounded-lg w-full text-sm bg-sky-500 border font-semibold' disabled={!isReady}>Pay</button>
          </div>
          
        </form>
      </main>
    </>
  );
};

export default PaymentPage;
